'use client';

import { ConfiguratorAddToCartMobile } from '@eliadmin/core/src/components/configurator/configurator-add-to-cart-mobile';
import { ConfiguratorMobilePreview } from '@eliadmin/core/src/components/configurator/configurator-mobile-preview';
import { Button } from '@eliadmin/core/src/components/ui/button';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { useCleanConfiguratorMutation } from '@eliadmin/core/src/stores/configurator-store';
import { RiBrush3Line } from 'react-icons/ri';

export function ConfiguratorMobileMenu() {
  const cleanMutation = useCleanConfiguratorMutation();
  const { t } = useTranslations();
  return (
    <div className="ea-configurator__mobile-menu fixed bottom-0 grid w-full grid-cols-2 gap-4 bg-background p-4 md:hidden">
      <ConfiguratorAddToCartMobile />

      <ConfiguratorMobilePreview />

      <Button
        variant={'ghost'}
        className="
          col-span-1
          flex items-center justify-center
          gap-2.5
          text-base
          font-medium
          text-accent
      "
        onClick={() => cleanMutation.mutate()}
        isLoading={cleanMutation.isPending}
      >
        <RiBrush3Line size={20} /> {t('text632')}
      </Button>
    </div>
  );
}
